import React from 'react'
import { DocumentSummary } from '../types'
import { documentStatusMeta, isBusy } from '../utils'

type Props = { doc?: Pick<DocumentSummary, 'status' | 'stalled'> }

/** Uppercase status badge; documents being worked on get a pulsing dot. */
const StatusBadge: React.FC<Props> = ({ doc }) => {
  const meta = documentStatusMeta(doc)
  return (
    <span
      className={`dx-badge dx-badge--${meta.tone}`}
      title={
        doc?.stalled
          ? 'Waiting much longer than processing takes — process it again'
          : undefined
      }
    >
      {isBusy(doc) && <span className="dx-badge__pulse" aria-hidden />}
      {meta.label}
    </span>
  )
}

export default StatusBadge
